import { useContext } from 'react';
import { AssessmentContext } from './assessment.context';

export const useAssessment = () => {
  return useContext(AssessmentContext);
};
